import { components, OptionProps } from "react-select";
import { SelectOption } from "./types";

const CustomOption = (props: OptionProps<SelectOption>) => {
  return (
    <div>
      <components.Option {...props}>
        <input
          type="checkbox"
          checked={props.isSelected}
          onChange={() => null} />
          {" "}
        <label>{props.label}</label>
      </components.Option>
    </div>
  );
};

export default CustomOption;
